import React from 'react';

const InfoIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.00007 12.2002C8.85279 12.2002 8.7334 12.3196 8.7334 12.4669C8.7334 12.6141 8.85279 12.7335 9.00007 12.7335C9.14734 12.7335 9.26673 12.6141 9.26673 12.4669C9.26673 12.3196 9.14734 12.2002 9.00007 12.2002V12.2002" stroke="#FAC83B" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 10.0669V4.2002" stroke="#FAC83B" strokeLinecap="round"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="#FAC83B"/>
  </svg>
)

export default InfoIcon